import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import 'react-datepicker/dist/react-datepicker.css'

import {Row, Column} from "../../components/Layout";
import HereMap from "../../components/Map/HereMap";
import NTMTable from "../../components/Table/NTMTable";
import PageWithModal from "../../components/Page/PageWithModal";
import Image from "../../components/Image";
import EditLabelModal from "../../components/Modal/EditLabelModal";
import GeofencingPluginHereMap from "../../components/Map/plugins/circles";
import Toolbar from "../../components/Map/Toolbar";
import AssignDevicePanel from "../Dashboard/AssignDevicePanel";
import NTMButton from "../../components/Buttons/NTMButton";
import {PROJECTS, put} from "../../service/Client";
import {roles} from "../../constants";
import { editIcon, editIcon_over, pinIcon } from 'img/icons'
import style from '../Dashboard/style.module.scss'


export default class DashboardPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			zoom: 15,
			editMode: false,
		};

		this.geofencingPlugin = GeofencingPluginHereMap();
	}

	componentDidMount() {
		this.props.getStatus(this.props.project.id);
	}

	componentDidUpdate(prevProps) {
		if(prevProps.initialData !== this.props.initialData) {
			this.setState({
				geofencingPlugin: {
					plugin: GeofencingPluginHereMap(),
					initialData: this.props.initialData,
				}
			})
		}

		if(prevProps.project.id !== this.props.project.id) this.props.getStatus(this.props.project.id);
	}

	devicePopUp = (name, ts) => `<div class="bubble">
									<div class="name">id</div><div>${name}</div>
									<div class="name">ultimo contatto</div><div>${ts}</div>
								</div>`;

	disassociate = (device) => {
		put(`${PROJECTS}/${this.props.project.id}/devices`, {body:this.props.status.filter(d => d.deviceId !== device.deviceId).map(d => d.deviceId)})
			.then(() => this.props.getStatus(this.props.project.id))
	}

	updatePos = () => {
		let end = moment(this.state.endDate);
		let start = moment(this.state.startDate);
		let params = {
			millis: end.valueOf(),
			day: end.diff(start, 'days') + 1
		};
		this.props.getPositions(this.state.selected, params);
	};

	changeLabel = (label) => {
		this.props.changeLabel(this.props.project.id, this.state.isModalOpen, label);
		this.setState({isModalOpen:null})
	};

	onSelectGeofencingArea = circleShape => {
		this.setState({selectedGeofencingArea: circleShape});
		// this.geofencingPlugin.toggleMapListener();
	}

	onSubmitGeofencingArea = (areaInfo) => {
		const geofencingAreaDto = {
			id: areaInfo.id,
			label: areaInfo.label,
			lat: this.state.center.lat,
			lng: this.state.center.lng,
			radius: this.state.radius,
			devices: areaInfo.devices,
			type: areaInfo.type,
			projectId: this.props.project.id,
			projectName: this.props.project.name,
		}

		//  API call
		if (!this.state.editMode) {
			this.props.onSubmit(geofencingAreaDto)
				.then(resp => {
					this.geofencingPlugin.setData(resp);

					// Update the map
					this.geofencingPlugin.submitGeofencingArea(resp);
					this.geofencingPlugin.toggleMapListener();
				});
			} else {
				this.props.onUpdate(geofencingAreaDto);
				this.geofencingPlugin.submitGeofencingArea(geofencingAreaDto);
				this.geofencingPlugin.toggleMapListener();
		}

		this.setState({
			selectedGeofencingArea: null,
			selectedGeofencingAreaData: null,
			editMode: false,
		})
	}

	onRemoveGeofencingArea = () => {
		// Delete on Map
		const areaObj = this.state.selectedGeofencingArea;
		this.geofencingPlugin.mutateCircles.remove(areaObj);
		this.geofencingPlugin.toggleMapListener();

		if (!this.state.creatingNewArea) {
			// Delete on DB

			this.props.onDelete(this.state.selectedGeofencingAreaData);

		}

		this.setState({
			selectedGeofencingArea: null,
			editMode: false,
			creatingNewArea: false,
		})
	}

	_createInitialCircles = () => {
		return this.props.initialData.map(area => {
			let data

			try {
				data = area
			} catch (e) {
				console.error(e.message)
			}

			return {data};
		}
		)
	}

	render() {

		let markers = [];
		let center = {
			lat:40.967320,
			lng:17.115670
		};

		this.props.status.forEach(k => {
			if(k.lat && k.lng)
			markers.push({
				lat: k.lat,
				lng: k.lng,
				data: this.devicePopUp(k.label || k.deviceId, k.lastPositionTimestamp),
				icon: pinIcon
			});
		});

		if(this.state.selected) {
			markers = this.props.positions[this.state.selected] && this.props.positions[this.state.selected].reverse().map(p => {return {lat:p.lat, lng:p.lng, ts:p.timestamp, data: this.devicePopUp(this.state.selected, p.timestamp)};});
		}

		if(markers && markers.length > 0) center = this.state.center || {lat:markers[0].lat, lng:markers[0].lng};

		return (
			<PageWithModal
				message={this.state.message}
				confirm={this.state.confirm}
				{...this.props}
				error={this.state.error||this.props.error}
			>
				<Row className={style.box}>
						{this.props.dataFetchingError && (
							<h2>Si è verificato un errore. Ricarica la pagina o riprova più tardi</h2>
						)}
						{this.props.dataLoaded && <HereMap
							center={center}
							zoom={this.state.zoom}
							theme={"normal.day"}
							markers={markers}
							route={this.state.selected}
							className={style.map}
							plugins={[
								this.geofencingPlugin.initPlugin({
									setCenter: center => this.setState({center}),
									setRadius: radius => this.setState({radius: radius}),
									initialData: this.props.initialData,
									onSelectGeofencingArea: this.onSelectGeofencingArea,
									setData: data => this.setState({ selectedGeofencingAreaData: data}),
									setEditMode: value => this.setState({editMode: value}),
									setCreatingNewArea: value => this.setState({
										selectedGeofencingAreaData: null,
										creatingNewArea: value,
										}),
									initialZoom: this.state.zoom,
								})
							]}
						/>
						}
						{this.state.selectedGeofencingArea && <Toolbar
						area={this.state.selectedGeofencingArea}
						devices={this.props.status}
						onSubmit={this.onSubmitGeofencingArea}
						onRemove={this.onRemoveGeofencingArea}
						data={this.state.selectedGeofencingAreaData}
						/>}
				</Row>
				<Row className={style.box}>
						<NTMTable
							header={[
								{
									Header: "ID",
									accessor: 'deviceId',
									Cell: props => <Column><Row style={{justifyContent: "space-around"}}>
									<span
										style={{paddingRight: "0.5rem"}}>{props.original.deviceId}</span>
										{roles.isSuperUser(this.props.user) && <Row>
											<NTMButton primary onClick={() => this.disassociate(props.original)}>
												Rimuovi</NTMButton>
										</Row>}
									</Row>
									</Column>
								},
								{
									Header: "NOME",
									accessor: 'label',
									Cell: props => <Row style={{justifyContent: "space-around"}}>
										<span style={{paddingRight:"0.5rem"}}>{props.original.label}</span>
										<Image
											src={editIcon}
											hover={editIcon_over}
											onClick={() => this.setState({isModalOpen: props.original.deviceId})}
										/>
									</Row>
								},
								{
									Header: "ULTIMO CONTATTO",
									accessor: 'timestamp'
								},
								{
									Header: "TEMPERATURA",
									accessor: 'temperature',
									Cell: props => <div>{props.original.temperature}°</div>
								},
								{
									Header: "BATTERIA",
									accessor: 'bat',
									Cell: props =>
										<Row style={{alignItems:"center"}}>
											<Column className={`progress ${style.battery}`}>
												<div
													className="progress-bar"
													role="progressbar"
													aria-valuenow={props.original.bat}
													aria-valuemin="0"
													aria-valuemax="100"
													style={{width:props.original.bat+"%"}}
												/>
											</Column>
											<Column>
												{props.original.bat}%
											</Column>
										</Row>
								},
								{
									Cell: props =>
										<Link
											to={{
												pathname: `/devices/${props.original.deviceId}`
											}}
											className={style.link}
										>
											{"Visualizza storico"}
										</Link>
								}
								]}
							body={this.props.status}
						/>
				</Row>
				<EditLabelModal isOpen={!!this.state.isModalOpen}
				                onClose={() => this.setState({isModalOpen: !this.state.isModalOpen})}
				                onSubmit={this.changeLabel}
				/>
				<AssignDevicePanel devices={this.props.status.map(d => d.deviceId)} onSave={() => this.props.getStatus(this.props.project.id)}/>
			</PageWithModal>
		);
	}
}
